import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * 路由 pathname 变化时将页面滚动到顶部（hash 变化不触发，避免 Tab 切换被打断）。
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
